import { useClients } from '@entities/clients';
import { useClientIdsSelect } from '@entities/clients/heplers.ts';
import { useSetClientToGroupMutation } from '@entities/clients/rtk-query.ts';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ClientInfoWithList } from '@features/clients/client-info-with-list/index.tsx';
import { ToolbarDynamicButtons } from '@features/clients/client-toolbar-dynamic-buttons';
import { Search, useFilter } from '@features/common';
import { FilterIcon, SortIcon } from '@shared/assets';
import { useMobile } from '@shared/hooks';
import { IconButton, PageHead, PageTitle, TextButton } from '@shared/ui';

export const AddClients = () => {
  const { idGroup } = useParams();
  const navigate = useNavigate();
  const { isMobile } = useMobile();
  const { isSelecting, selectedIds, toggleSelectionMode, isNeedToSelectAll, excludedIds } =
    useClientIdsSelect();

  const [setClientToGroupMutation, { isLoading }] = useSetClientToGroupMutation();

  const { search, onSearch } = useFilter();
  const { nameClients, select } = useClients();

  const [searchNotes, setSearchNotes] = useState('');
  const [isSearchingMobile, setIsSearchingMobile] = useState(false);

  const onSearchToggle = useCallback(() => {
    isMobile && setIsSearchingMobile((isActive) => !isActive);
  }, [isMobile, setIsSearchingMobile]);

  useEffect(() => {
    !isSelecting && toggleSelectionMode();
    select(0);
  }, []);

  const listParams = { search: search, not_custom_group: idGroup };
  const setGroupAnyClients = async () => {
    if (isNeedToSelectAll || selectedIds?.length) {
      await setClientToGroupMutation({
        group: Number(idGroup),
        all: isNeedToSelectAll,
        users: selectedIds,
        exclude_users: excludedIds,
      });
    }
    navigate(`/clients/groups/${idGroup}`);
  };
  return (
    <>
      <PageTitle title={`Добавление клиента в группу`} />
      <PageHead
        Right={
          <>
            <Search
              onToggle={onSearchToggle}
              titles={nameClients}
              search={search}
              onSearch={onSearch}
              additionalChildren={
                isSearchingMobile ? undefined : <ToolbarDynamicButtons withActionButton={false} />
              }
            />
            {isSearchingMobile ? undefined : (
              <>
                <IconButton variant="dark">
                  <SortIcon />
                </IconButton>
                <IconButton variant="dark">
                  <FilterIcon />
                </IconButton>
                <TextButton type="submit" disabled={isLoading} onClick={setGroupAnyClients}>
                  Готово
                </TextButton>{' '}
              </>
            )}
          </>
        }
      />
      <ClientInfoWithList
        listParams={listParams}
        searchNotes={searchNotes}
        onSearchNotes={setSearchNotes}
      />
    </>
  );
};

export default AddClients;
